const Avatar = ({
  link,
  name = "User",
}: {
  link: string | null;
  name: string | null;
}) => {
  return (
    <div>
      {link ? (
        <img
          src={link}
          alt="Avatar"
          className="w-10 h-10 rounded-full border dark:border-gray-600"
        />
      ) : (
        <div className="w-10 h-10 rounded-full border bg-gray-200 flex items-center justify-center text-primary-600 font-semibold dark:bg-gray-700 dark:border-gray-600 dark:text-primary-300">
          {name?.charAt(0).toUpperCase()}
        </div>
      )}
    </div>
  );
};

export default Avatar;
